"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/goods/v1/portal_service.proto (package spwn.goods.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalGoodsService = void 0;
const portal_service_pb_1 = require("./portal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.goods.v1.PortalGoodsService
 */
exports.PortalGoodsService = {
    typeName: "spwn.goods.v1.PortalGoodsService",
    methods: {
        /**
         * グッズの単体取得
         *
         * @generated from rpc spwn.goods.v1.PortalGoodsService.GetGoods
         */
        getGoods: {
            name: "GetGoods",
            I: portal_service_pb_1.PortalGoodsServiceGetGoodsRequest,
            O: portal_service_pb_1.PortalGoodsServiceGetGoodsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.goods.v1.PortalGoodsService.GetGoodsMetadata
         */
        getGoodsMetadata: {
            name: "GetGoodsMetadata",
            I: portal_service_pb_1.PortalGoodsServiceGetGoodsMetadataRequest,
            O: portal_service_pb_1.PortalGoodsServiceGetGoodsMetadataResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * グッズの一覧取得
         *
         * @generated from rpc spwn.goods.v1.PortalGoodsService.GetGoodsList
         */
        getGoodsList: {
            name: "GetGoodsList",
            I: portal_service_pb_1.PortalGoodsServiceGetGoodsListRequest,
            O: portal_service_pb_1.PortalGoodsServiceGetGoodsListResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=portal_service_connect.js.map